import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { roleData } from "../validation/profileData.validation";

const useAccountProgressAPI = () => {
  const { auth } = useSelector((state) => state.auth);
  const [data, setData] = useState({ progress: 0, missingFields: [] });

  useEffect(() => {
    if (auth && Object.keys(auth.user).length > 0) {
      const userRoleFields = roleData(auth.user);
      let filteredFields;

      //console.log("User Role Fields:", userRoleFields);

      // Filter fields based on job status
      if (userRoleFields.jobState && userRoleFields.jobState.toLowerCase().includes("employe")) {
        filteredFields = Object.entries(userRoleFields).filter(
          ([key]) => key !== "where_you_know_us"
        );
      } else if (userRoleFields.jobState && (userRoleFields.jobState.toLowerCase() === "freelancer" || userRoleFields.jobState.toLowerCase() === "currently not working")) {
        filteredFields = Object.entries(userRoleFields).filter(
          ([key]) => key !== "where_you_know_us" && key !== 'companyName'
        );
      } else if (userRoleFields.jobState && userRoleFields.jobState.toLowerCase() === "student") {
        filteredFields = Object.entries(userRoleFields).filter(
          ([key]) => key !== "where_you_know_us" && key !== 'companyName' && key !== 'experienceYears'
        );
      } else {
        // Default case - include jobState in progress calculation
        filteredFields = Object.entries(userRoleFields).filter(
          ([key]) => key !== "where_you_know_us"
        );
        // If no jobState is set, add it as a missing field for progress calculation
        if (!userRoleFields.jobState) {
          filteredFields.push(['jobState', '']);
        }
      }

      const userRoleFieldsCount = filteredFields.length;

      // Identify empty fields
      const missingFields = filteredFields
        .filter(
          ([_, value]) => value === undefined || value === null || value === ""
        )
        .map(([key]) => key);

      // Calculate and set progress
      const progress = userRoleFieldsCount > 0 
        ? Math.round(((userRoleFieldsCount - missingFields.length) / userRoleFieldsCount) * 100)
        : 0;
        
      setData({ progress, missingFields });
    }
  }, [auth]); // Add jobStatus to dependency array

  return data;
};

export default useAccountProgressAPI;